import { call, put, takeLatest } from 'redux-saga/effects';
import jwtDecode from 'jwt-decode';
import actions, { Types } from '~/store/ducks/profile';
import api from '~/services/api';
import { getToken } from '~/services/auth';

function* loadProfile() {
  try {
    const { data } = yield call(api.get, '/v1/me');
    const res = yield call(api.get, '/v1/partners?count=99999999');

    const partners = res.data.entries;
    const selectedPartner = partners[0];

    const tokenData = jwtDecode(getToken());

    const partnerPermissions = tokenData.permissions.find(
      ({ partner_id }) => partner_id === selectedPartner.id
    );

    const permissions =
      data.type === 'admin'
        ? data.profiles.map(p => p.permissions).reduce((a, b) => [...a, ...b])
        : partnerPermissions.permissions;

    const me = {
      id: data.id,
      name: data.name,
      email: data.email,
      type: data.type,
      permissions
    };

    yield put(actions.setPartners(partners));
    yield put(actions.loadProfileSuccess(me, selectedPartner));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

const sagas = [takeLatest(Types.LOAD_PROFILE, loadProfile)];

export default sagas;
